class ScrollDownOnClick {
    constructor() {
      console.log("ScrollDownOnClick Initialized");
      this.scrollButtons = document.querySelectorAll(".block-admin-curated-banner__scroll-button, .curated-banner__scroll-button");

      this.events();
    }
  
    // events
    events() {
      this.scrollButtons.forEach(button => {
        button.addEventListener("click", (e) => this.scrollToNextViewport(e));
      });
    }
  
    // methods
    scrollToNextViewport(e) {
      e.preventDefault();
      window.scrollBy({
        top: window.innerHeight * 0.9, 
        left: 0, 
        behavior: 'smooth'
      });
    }
  }
  
  export default ScrollDownOnClick;